<template>
  <div
    class="radioBlocks__wrapper"
  >
    <template v-if="props.data.options !== 'error' && props.data.options.length && Object.keys(props.data.options).length">
      <div
        :set="currentOption = props.data.options.find(n => n.value === selectedItem)"
        class="radioBlocks"
        :class="[{ isBlockStyle: props.data.additionalOptions.isBlockStyle }, props.data.additionalOptions.parentClasses]"
      >
        <label
          v-for="item, i in props.data.options"
          :key="i"
          :class="[item.classes, { active: selectedItem === item.value }]"
          class="flex cursor-pointer !w-full sm:!w-auto"
        >
          <RadioButton 
            v-model="selectedItem"
            :input-id="props.data.id"
            v-bind="props.data.field"
            :disabled="props.data.disabled"
            :value="item.value"
            :name="props.data.name"
            :class="[props.data.errorMessage ? 'invalid' : 'valid', props.data.elementClasses, { 'hidden': props.data.additionalOptions.isBlockStyle } ]"
          />

          <span class="pl-2 leading-normal">
            <span 
              v-if="item.icon"
              class="icon font-extralight"
              :class="item.icon"
            ></span>

            <span class="info">
              <span
                v-if="item.name"
                class="info__title"
                :class="{ 'opacity-50': item.inactive }"
              >{{ item.name }}</span>
              
              <span
                v-if="item.descr"
                class="small regular info__descr"
                :class="{ 'opacity-50': item.inactive }"
              >{{ item.descr }}</span>
            </span>
          </span>
        </label>
      </div>

      <template v-if="currentOption && currentOption.error">
        <span class="left helper-text invalid">{{ currentOption.error }}</span>
      </template>
    </template>
    
    <template v-else>
      <span class="left helper-text invalid">{{ $t('paymentTypeEmpty') }}</span>
    </template>
  </div>
</template>

<script setup>
/**
 * Params
 * additionalOptions: {
 *   isBlockStyle: true
 * }, 
 * options: {
 *   name: item.shipping_method,
 *   value: item.shipping_method_code,
 *   descr: false,
 *   error: item.error,
 *   disabled: false
 * }
 */
const selectedItem = ref('')

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})

/**
* Emits
*/
const emit = defineEmits(['returnData'])

/*
* Selected Item
*/
onUpdated(() => {
  if (props.data.options.length) {
    if (props.data.formData[props.data.name] && props.data.options.find(n => n.value === props.data.formData[props.data.name])) {
      selectedItem.value = props.data.formData[props.data.name]
    } else {
      selectedItem.value = props.data.options[0] ? props.data.options[0].value : props.data.value
    }
  } else {
    selectedItem.value = props.data.value
  }
})

/**
* Change Selected Item
*/
watch(selectedItem, (newA) => {
  emit('returnData', newA)
}, { deep: true })
</script>

<style lang="scss" scoped>
.radioBlocks {
  & > label {
    transform: inherit!important;
    &:before,
    &:after {
      display: none;
    }
  }

  &:not(.isBlockStyle) {
    & > label {
      display: flex;
      padding: 5px 0;
    }

    .info {
      &__title {
        color: color("primary-color", "base-2");
      }
      &__descr {
        color: color("primary-color", "base-2");
      }
    }
  }

  &.isBlockStyle {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -.5rem;
    & > label {
      padding: .5rem;

      &.active {
        color: #fff;
        & > span {
          color: $radio-block-active-title-color;
          background: $radio-block-active-bg;
          &:before {
            border-color: #fff;
          }
          &:after {
            background-color: #fff;
            border-color: #fff;
          }
          .info {
            &__title {
              color: $radio-block-active-title-color;
            }
            &__descr {
              color: $radio-block-active-descr-color;
            }
          }
        }
      }
      input {
        & + span {
          &:before,
          &:after {
            display: none;
          }
        }
      }
      & > span {
        display: flex;
        align-items: center;
        width: 100%;
        height: 48px;
        padding: 0 24px;
        margin: 0;
        color: #131313;
        background: $radio-block-bg;
        border: 1.5px solid #131313;
        border-radius: 4px;

        &:before,
        &:after {
          top: 50%;
          transform: translate(1rem, calc(-50% - 3px));
        }

        .icon {
          padding: 0 .3rem;
          font-size: 20px;
        }

        .info {
          display: flex;
          flex-direction: column;
          padding: 0 .3rem;

          &__title {
            color: $radio-block-title-color;
            font-weight: 400;
            text-transform: uppercase;
          }
          &__descr {
            color: $radio-block-descr-color;
          }
        }
      }
    }
  }
  &__wrapper {
    .helper-text {
      text-align: left !important;
    }
  }
}
</style>
